// extracted by mini-css-extract-plugin
export default {"maxWidth":"UsHyit4R"};